<div class="sanitization">
	<div [ngClass]="blackground ? 'black' : ''"></div>
</div>